import Login from "../pages/Login";
const publicRoutes = [
  { path: "/", element: <Login /> },
  { path: "/login", element: <Login /> }
];

export default publicRoutes;